<p-button (onClick)="showDialog = true">Razdvoji</p-button>

<ng-container *ngIf="showDialog">
  <p-dialog
    [resizable]="false"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{width: '100vw', height: '50vh'}"
    appendTo="body"
  >
    <h2>Odaberite predmet za razdvajanje: </h2>
    <div *ngIf="this.itemPredmetId">
      <app-odaberi-predmet [currentViewName]="'seup_predmet_u_radu_razdvajanje'" [itemPredmetId]="this.itemPredmetId" (itemSelected)="onSelectedItem($event)"></app-odaberi-predmet>
    </div>
  </p-dialog>
</ng-container>
